'use strict';

require('./tips_frontend_builder');

const paginationHelper = require('../../helpers/frontend/pagination');
const tipsPaginationFooter = require('../../pagination/main.html.mustache');
const tipRowTemplateTouch = require('../tip_row_touch.html.mustache');
const tipRowTemplateDesktop = require('../tip_row_desktop.html.mustache');

class Tips {
  constructor({
    el,
    csrf,
    placeId,
    offset,
    tipCount,
    maxTipLength,
    minTipLength,
    tipSubmitter,
    tipEvents,
    userTipOwnershipModel,
    isTouch,
  }) {
    this.render = this.render.bind(this);
    this.getNewTipsPage = this.getNewTipsPage.bind(this);
    this.getNewTipsSortingMethod = this.getNewTipsSortingMethod.bind(this);
    this.toggleSortingMethod = this.toggleSortingMethod.bind(this);
    this.getTips = this.getTips.bind(this);
    this.reportTip = this.reportTip.bind(this);
    this.removeTip = this.removeTip.bind(this);
    this.likeTip = this.likeTip.bind(this);
    this.unlikeTip = this.unlikeTip.bind(this);
    this.updateLikeStatus = this.updateLikeStatus.bind(this);
    this.updateTotalTipCount = this.updateTotalTipCount.bind(this);
    this.onTipSubmitSuccess = this.onTipSubmitSuccess.bind(this);
    this.el = el;
    this.csrf = csrf;
    this.placeId = placeId;
    this.offset = offset;
    this.tipCount = tipCount;
    this.maxTipLength = maxTipLength;
    this.minTipLength = minTipLength;
    this.tipSubmitter = tipSubmitter;
    this.tipEvents = tipEvents;
    this.userTipOwnershipModel = userTipOwnershipModel;
    this.isTouch = isTouch;
    this.$el = $(this.el);
    this.rootUrl = '/merchant-page';
    this.$tipText = this.$el.find('.tip-text');
    this.$tipCounter = this.$el.find('.tip-counter');
    this.maxTipLength = parseInt(this.$tipText.attr('maxlength'));
    this.$shareTip = this.$el.find('.share-tip');
    this.$loading = this.$el.find('.loading');
    this.$tipsTable = this.$el.find('.tips-table');
    this.$tipDelete = this.$el.find('.tip-delete');
    this.$tipsContainer = this.$el.find('.tips-container');
    this.$errorMessages = this.$el.find('.error-messages');
    this.$tipsOverlay = this.$el.find('#tips-load-overlay');
    this.$carat = this.$el.find('.carat');
    this.$tipsTotal = this.$el.find('.tips-total');
    this.$tipsFiltering = this.$el.find('.tips-filtering');
    this.$sortRecent = this.$el.find('.sort-recent');
    this.$sortHelpful = this.$el.find('.sort-helpful');
    this.reportedTipIds = [];
    this.sortingMethod = 'date';
    this.setPlaceHolder();
    this.bindEventHandlers();
    this.setFilteringDisplay();
  }

  bindEventHandlers() {
    this.$sortRecent.on('click', () => this.getNewTipsSortingMethod('date'));
    this.$sortHelpful.on('click', () =>
      this.getNewTipsSortingMethod('helpfulness')
    ); // these are delegated event handlers so that they also work for tips being added after page load

    this.$tipsTable.on('click', '.pagination a', this.getNewTipsPage);
    this.$tipsTable.on('click', '.tip-delete', this.removeTip);
    this.$tipsTable.on('click', '.tip-report', this.reportTip);
    this.$tipsTable.on('click', '.like-tip', this.likeTip);
    this.$tipsTable.on('click', '.unlike-tip', this.unlikeTip); // Custom events

    this.tipEvents.on('tipSubmitSuccess', this.onTipSubmitSuccess);
    this.userTipOwnershipModel.on('change:userHasTips', this.render);
  } // Render, in the meaning of, 'update the html to reflect any models we have'

  render() {}

  setPlaceHolder() {
    // if there are no tips and the screen is big enough, change the placeholder copy
    if (this.tipCount > 0 || $(document).width() <= 350) {
      return;
    }

    this.$tipText.attr(
      'placeholder',
      window.I18n.t('js.modules.tips.placeholder_first')
    );
  }

  setFilteringDisplay() {
    if (!(this.$tipsFiltering.length > 0)) {
      return;
    }

    const obj = {
      placeId: this.placeId,
      tips_page: 1,
      slug: window.location.pathname.slice(5),
      sortingMethod: 'helpfulness',
    };

    $.ajax({
      url: `${this.rootUrl}/tips/get`,
      method: 'GET',
      data: obj,
      contentType: 'application/json',
      success: res => {
        if (res.result !== 'ok') {
          return;
        }

        const hasLikedTips = res.data.tips.tips.some(tip => tip.likeCount > 0);

        if (hasLikedTips) {
          this.$tipsFiltering.removeClass('hide');
        }
      },
    });
  }

  getNewTipsPage(event) {
    event.preventDefault();
    const pageNumber = $(event.currentTarget).data('page');
    const slug = window.location.pathname.slice(5);
    const originalQueryParams = window.location.search;
    const obj = {
      placeId: this.placeId,
      tips_page: pageNumber,
      slug,
      sortingMethod: this.sortingMethod,
      originalQueryParams:
        originalQueryParams.length > 0 ? originalQueryParams : undefined,
    };
    this.$tipsOverlay.show();
    $('html, body').animate(
      {
        scrollTop: this.$el.offset().top - 150,
      },
      100
    );
    this.getTips(obj);
  }

  getNewTipsSortingMethod(sortingMethod) {
    if (sortingMethod === this.sortingMethod) {
      return;
    }

    const slug = window.location.pathname.slice(5);
    const originalQueryParams = window.location.search;
    const obj = {
      placeId: this.placeId,
      tips_page: 1,
      slug,
      sortingMethod,
      originalQueryParams:
        originalQueryParams.length > 0 ? originalQueryParams : undefined,
    };
    this.$tipsOverlay.show();
    $('html, body').animate(
      {
        scrollTop: this.$el.offset().top - 10,
      },
      100
    );
    this.getTips(obj, true);
  }

  toggleSortingMethod(sortingMethod) {
    if (sortingMethod === false) {
      return;
    }

    this.sortingMethod = sortingMethod;
    this.$sortRecent.toggleClass('clickable');
    this.$sortHelpful.toggleClass('clickable');
  }

  getTips(data, isNewSortingMethod = false) {
    $.ajax({
      url: `${this.rootUrl}/tips/get`,
      method: 'GET',
      data,
      contentType: 'application/json',
      success: res => {
        // TODO: error handling
        this.$tipsOverlay.hide();

        if (res.result !== 'ok') {
          return;
        }

        if (isNewSortingMethod) {
          this.toggleSortingMethod(data.sortingMethod);
        }

        this.updateTipsRows(res.data.tips);
        this.updatePagination(res.data.tips);
        this.updateHeadTags(res.data.tips && res.data.tips.paginationFooter);
        paginationHelper.updateUrl(
          res.data.tips &&
            res.data.tips.paginationFooter &&
            res.data.tips.paginationFooter.currentPageNumber,
          'tips_page'
        ); // this is needed for the "Verified Customer" tooltip

        window.GIG &&
          window.GIG.Tooltip &&
          window.GIG.Tooltip.reloadBindings($('.tips-module .tips-container'));
      },
      error: () => {
        this.$tipsOverlay.hide();
      },
    }); // TODO: getMoreTips error handling

    return true;
  }

  updateTipsRows(data) {
    data.translate = data.t = () => text => window.I18n.translate(text);

    let html = '';

    for (const singleRowData of data != null ? data.tips : undefined) {
      html += this.generateRow(singleRowData);
    }

    this.$tipsTable.html(html);
  }

  updatePagination(data) {
    data.translate = data.t = () => text => window.I18n.translate(text);
    data.isTouch = this.isTouch;

    let html = '';
    html = tipsPaginationFooter.render(data);
    this.$tipsTable.append(html);
  }

  updateHeadTags(data) {
    this.updatePrevTag(data && data.relPrevUrl);
    this.updateNextTag(data && data.relNextUrl);
    this.updateCanonicalTag(data && data.currentPageNumber);
    this.updateRobots(data && data.currentPageNumber);
  }

  updatePrevTag(previousUrl) {
    if (!previousUrl) {
      $('head link[rel=prev]').remove();
      return;
    }

    const $prev = $('head link[rel=prev]');

    if ($prev.length > 0) {
      $prev.attr('href', previousUrl);
    } else {
      $('head').append(`<link rel='prev' href='${previousUrl}'>`);
    }
  }

  updateNextTag(nextUrl) {
    if (!nextUrl) {
      $('head link[rel=next]').remove();
      return;
    }

    const $next = $('head link[rel=next]');

    if ($next.length > 0) {
      $('head link[rel=next]').attr('href', nextUrl);
    } else {
      $('head').append(`<link rel='next' href='${nextUrl}'>`);
    }
  }

  updateCanonicalTag(currentPageNumber) {
    const $canonical = $('head link[rel=canonical]');
    let canonicalUrl = $canonical.attr('href');
    const queryIndex = canonicalUrl.indexOf('?');

    if (queryIndex !== -1) {
      canonicalUrl = canonicalUrl.substring(0, queryIndex);
    }

    const tipsQueryParam = `?tips_page=${currentPageNumber}`;

    if (currentPageNumber !== 1) {
      canonicalUrl = `${canonicalUrl}${tipsQueryParam}`;
    }

    $canonical.attr('href', canonicalUrl);
  }

  updateRobots(currentPageNumber) {
    const $head = $('head');

    if (currentPageNumber > 1) {
      $head.append("<meta name='robots' content='noindex,follow'>");
    }
  }

  reportTip(evt) {
    const $tipReport = $(evt.target);
    const $tipDeleteAndReport = $tipReport.closest('.delete-and-report');
    const $tip = $tipDeleteAndReport.closest('.tip-row');
    const tipId = $tip.data('tip-id');

    const cb = () => {
      $tipReport
        .removeClass('tip-report')
        .removeClass('show-on-hover')
        .text(window.I18n.translate('js.modules.tips.reported'));
      $tipDeleteAndReport
        .find('.tip-report-separator')
        .removeClass('show-on-hover');
      this.reportedTipIds.push(tipId);
    };

    $.ajax({
      url: `${this.rootUrl}/tips/${tipId}/flag`,
      method: 'POST',
      data: JSON.stringify({
        _csrf: this.csrf,
      }),
      contentType: 'application/json',
      success: res => {
        if (!window.MPP.JsonResponseHandler.loginRequired(res)) {
          cb();
        }
      },
    });
  }

  removeTip(evt) {
    const $tip = $(evt.target).closest('.tip-row');

    const id = $tip.data('tip-id');
    const obj = {
      _csrf: this.csrf,
      tipId: id,
    }; // TODO: show a loading spinner or something

    $.ajax({
      url: `${this.rootUrl}/tips/delete`,
      method: 'POST',
      data: JSON.stringify(obj),
      contentType: 'application/json',
      success: res => {
        if (window.MPP.JsonResponseHandler.loginRequired(res)) {
          return;
        } // TODO: handle other errors

        if (res.result !== 'ok') {
          return;
        }

        this.updateTotalTipCount(this.tipCount - 1); // animate and remove row, then show share tip box

        $tip.slideUp('fast', () => {
          $tip.remove(); // Show the share tip box if the user hasn't posted any more tips on
          // this merchant page.
          // NOTE: this might cause an issue when the user has posted more tips
          // than what is currently being shown, but that would only happen if
          // the user has submited 10+ surveys, which is an *extremely* rare
          // case.

          if (this.$el.find('.tip-row.user-is-owner').length === 0) {
            this.userTipOwnershipModel.set('userHasTips', false);
          }
        }); // update the footer
        // hide if there are no tips

        if (this.tipCount <= 0) {
          this.$tipsContainer.addClass('hidden');
        }
      },
    });

    return false;
  }

  likeTip(evt) {
    const $tip = $(evt.target).closest('.tip-row');
    const tipId = $tip.data('tip-id');

    $.ajax({
      url: `${this.rootUrl}/tips/${tipId}/like`,
      method: 'POST',
      data: JSON.stringify({
        _csrf: this.csrf,
      }),
      contentType: 'application/json',
      success: res => {
        if (res.result === 'ok') {
          this.updateLikeStatus($tip, res.data);
        } else {
          window.MPP.JsonResponseHandler.loginRequired(res);
        }
      },
    });
  }

  unlikeTip(evt) {
    const $tip = $(evt.target).closest('.tip-row');
    const tipId = $tip.data('tip-id');
    $.ajax({
      url: `${this.rootUrl}/tips/${tipId}/unlike`,
      method: 'POST',
      data: JSON.stringify({
        _csrf: this.csrf,
      }),
      contentType: 'application/json',
      success: res => {
        if (res.result === 'ok') {
          this.updateLikeStatus($tip, res.data);
        } else {
          window.MPP.JsonResponseHandler.loginRequired(res);
        }
      },
    });
  }

  updateLikeStatus($tip, data) {
    const tipRow = this.generateRow(data);
    $tip.replaceWith(tipRow);
  }

  updateTotalTipCount(newTipCount) {
    this.tipCount = newTipCount;
    const newText = window.I18n.translate('js.modules.tips.total_tips', {
      count: newTipCount,
    });
    this.$tipsTotal.html(newText);
  }

  onTipSubmitSuccess(res) {
    // for initial case, show tips
    this.$tipsContainer.removeClass('hidden'); // add the tip

    this.prependNewTip(res.data);
    this.updateTotalTipCount(this.tipCount + 1);
  }

  generateRow(data) {
    this.updateTipReported(data);

    data.translate = data.t = () => text => window.I18n.translate(text);

    return this.isTouch
      ? tipRowTemplateTouch.render(data)
      : tipRowTemplateDesktop.render(data);
  }

  prependNewTip(data) {
    const $row = $(this.generateRow(data)); // hide it first to get the nice slideDown animation

    $row.hide();
    this.$tipsTable.prepend($row);
    $row.slideDown();
  }

  updateTipReported(data) {
    // Need to check both data.reported and @reportedTipIds because once a user
    // reports a tip, the "flag" user action may not appear in the API response
    // right away due to caching.
    data.reported =
      data.reported || window._.contains(this.reportedTipIds, data.id);
    data.reported;
  }
}

Groupon.Tips = Tips;
